import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RowLayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { LayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/layout-metadata.model';
import { ItemMetadata } from '../../../../model/dyn-form/form-metadata/item/item-metadata.model';
import { ValueItemMetadata } from '../../../../model/dyn-form/form-metadata/item/value-item-metadata.model';
import { MatIconModule } from '@angular/material/icon';
import { SafePipe } from '../../../../pipe/safe.pipe';

@Component({
    selector: 'app-dynamic-view-row-layout',
    templateUrl: './dynamic-view-row-layout.component.html',
    styleUrls: ['./dynamic-view-row-layout.component.scss'],
    standalone: true,
    providers: [
        DatePipe
    ],
    imports: [
        CommonModule,
        MatIconModule,
        SafePipe
    ]
})
export class DynamicViewRowLayoutComponent implements OnInit {



    @Input()
    set layout(p: LayoutMetadataBase) {
        this.rowLayout = <RowLayoutMetadataBase>p
    }

    @Input()
    value: any

    @Input()
    fieldVisibility!: Map<string, boolean>

    rowLayout!: RowLayoutMetadataBase

    constructor(public datePipe: DatePipe) { }

    ngOnInit(): void {
    }

    toDate(val: any): string {
        if (val == null) {
            return '-'
        }
        let date = new Date(val)
        return "" + this.datePipe.transform(date, 'dd/MM/yyyy')
    }

    toHtml(item: ItemMetadata): ValueItemMetadata {
        return <ValueItemMetadata>item
    }

    toTime(val: any): string {
        if (val == null) {
            return '-'
        }
        let hour = `${val['hours']}`
        if (hour.length == 1) {
            hour = '0' + hour
        }
        let min = `${val['minutes']}`
        if (min.length == 1) {
            min = '0' + min
        }
        return `${hour}:${min}H`
    }

    keys(obj: any): any[] {
        if (obj == null) {
            return []
        }
        return Object.keys(obj)
    }

    emptyValue(value: any | null): string {
        if (value == null) {
            return "-"
        }
        return value
    }

    isVisible(fieldName: string) {
        if (this.fieldVisibility) {
            return this.fieldVisibility.get(fieldName) ?? true   
        }
        return true
    }

}
